var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUsIconPatternFly1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 219.839,
    height: 109.021,
    viewBox: "0 0 219.839 109.021",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contact_us6",
    transform: "translate(47.92 -1312.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contact_us6-2",
    "data-name": "contact_us6",
    transform: "translate(62 1314.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail_icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-2",
    "data-name": "mail_icon",
    d: "M.012,25.441s25.461-11.2,25.423-12.721S.012,0,.012,0L0,9.894s18.144,1.821,18.168,2.827S0,15.547,0,15.547Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 16.35)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-3",
    "data-name": "mail_icon",
    transform: "translate(36.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-4",
    "data-name": "mail_icon",
    d: "M.012,25.441s25.461-11.2,25.423-12.721S.012,0,.012,0L0,9.894s18.144,1.821,18.168,2.827S0,15.547,0,15.547Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 16.35)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-5",
    "data-name": "mail_icon",
    transform: "translate(72.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-6",
    "data-name": "mail_icon",
    d: "M.012,25.441s25.461-11.2,25.423-12.721S.012,0,.012,0L0,9.894s18.144,1.821,18.168,2.827S0,15.547,0,15.547Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 16.35)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-7",
    "data-name": "mail_icon",
    transform: "translate(0 34.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-8",
    "data-name": "mail_icon",
    d: "M.012,25.441s25.461-11.2,25.423-12.721S.012,0,.012,0L0,9.894s18.144,1.821,18.168,2.827S0,15.547,0,15.547Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 16.35)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-9",
    "data-name": "mail_icon",
    transform: "translate(36.166 34.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-10",
    "data-name": "mail_icon",
    d: "M.012,25.441s25.461-11.2,25.423-12.721S.012,0,.012,0L0,9.894s18.144,1.821,18.168,2.827S0,15.547,0,15.547Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 16.35)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-11",
    "data-name": "mail_icon",
    transform: "translate(72.33 34.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-12",
    "data-name": "mail_icon",
    d: "M.012,25.441s25.461-11.2,25.423-12.721S.012,0,.012,0L0,9.894s18.144,1.821,18.168,2.827S0,15.547,0,15.547Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 16.35)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-13",
    "data-name": "mail_icon",
    transform: "translate(0 69.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-14",
    "data-name": "mail_icon",
    d: "M.012,25.441s25.461-11.2,25.423-12.721S.012,0,.012,0L0,9.894s18.144,1.821,18.168,2.827S0,15.547,0,15.547Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 16.35)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-15",
    "data-name": "mail_icon",
    transform: "translate(36.166 69.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-16",
    "data-name": "mail_icon",
    d: "M.012,25.441s25.461-11.2,25.423-12.721S.012,0,.012,0L0,9.894s18.144,1.821,18.168,2.827S0,15.547,0,15.547Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 16.35)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-17",
    "data-name": "mail_icon",
    transform: "translate(72.33 69.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-18",
    "data-name": "mail_icon",
    d: "M.012,25.441s25.461-11.2,25.423-12.721S.012,0,.012,0L0,9.894s18.144,1.821,18.168,2.827S0,15.547,0,15.547Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 16.35)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "contact_us6-3",
    "data-name": "contact_us6",
    transform: "translate(-46.168 1314.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-19",
    "data-name": "mail_icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-20",
    "data-name": "mail_icon",
    d: "M.012,25.441s25.461-11.2,25.423-12.721S.012,0,.012,0L0,9.894s18.144,1.821,18.168,2.827S0,15.547,0,15.547Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 16.35)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-21",
    "data-name": "mail_icon",
    transform: "translate(36.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-22",
    "data-name": "mail_icon",
    d: "M.012,25.441s25.461-11.2,25.423-12.721S.012,0,.012,0L0,9.894s18.144,1.821,18.168,2.827S0,15.547,0,15.547Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 16.35)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-23",
    "data-name": "mail_icon",
    transform: "translate(72.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-24",
    "data-name": "mail_icon",
    d: "M.012,25.441s25.461-11.2,25.423-12.721S.012,0,.012,0L0,9.894s18.144,1.821,18.168,2.827S0,15.547,0,15.547Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 16.35)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-25",
    "data-name": "mail_icon",
    transform: "translate(0 34.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-26",
    "data-name": "mail_icon",
    d: "M.012,25.441s25.461-11.2,25.423-12.721S.012,0,.012,0L0,9.894s18.144,1.821,18.168,2.827S0,15.547,0,15.547Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 16.35)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-27",
    "data-name": "mail_icon",
    transform: "translate(36.166 34.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-28",
    "data-name": "mail_icon",
    d: "M.012,25.441s25.461-11.2,25.423-12.721S.012,0,.012,0L0,9.894s18.144,1.821,18.168,2.827S0,15.547,0,15.547Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 16.35)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-29",
    "data-name": "mail_icon",
    transform: "translate(72.33 34.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-30",
    "data-name": "mail_icon",
    d: "M.012,25.441s25.461-11.2,25.423-12.721S.012,0,.012,0L0,9.894s18.144,1.821,18.168,2.827S0,15.547,0,15.547Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 16.35)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-31",
    "data-name": "mail_icon",
    transform: "translate(0 69.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-32",
    "data-name": "mail_icon",
    d: "M.012,25.441s25.461-11.2,25.423-12.721S.012,0,.012,0L0,9.894s18.144,1.821,18.168,2.827S0,15.547,0,15.547Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 16.35)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-33",
    "data-name": "mail_icon",
    transform: "translate(36.166 69.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-34",
    "data-name": "mail_icon",
    d: "M.012,25.441s25.461-11.2,25.423-12.721S.012,0,.012,0L0,9.894s18.144,1.821,18.168,2.827S0,15.547,0,15.547Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 16.35)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-35",
    "data-name": "mail_icon",
    transform: "translate(72.33 69.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-36",
    "data-name": "mail_icon",
    d: "M.012,25.441s25.461-11.2,25.423-12.721S.012,0,.012,0L0,9.894s18.144,1.821,18.168,2.827S0,15.547,0,15.547Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 16.35)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsIconPatternFly1);
export default __webpack_public_path__ + "static/media/contact_us_icon_pattern_fly1.867d40e37dae45b9f7b2a5d418b337d0.svg";
export { ForwardRef as ReactComponent };